/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditSingleServiceCommissionPercentApiRequest } from '../../models/hotel-edit-single-service-commission-percent-api-request';

export interface ApiHotelManageEditSingleServiceCommissionPercentPost$Params {
      body: HotelEditSingleServiceCommissionPercentApiRequest
}

export function apiHotelManageEditSingleServiceCommissionPercentPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditSingleServiceCommissionPercentPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditSingleServiceCommissionPercentPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditSingleServiceCommissionPercentPost.PATH = '/api/hotel/manage/edit/single/service-commission-percent';
